import React from 'react';
import { twMerge } from 'tailwind-merge';
import { ReactComponent as WarningIcon } from 'assets/icons/big-warning.svg';
import { SUPPORT_EMAIL } from '../../../utilities/constants';

const ExpiredToken = () => {
  return (
    <div
      className={twMerge(
        'm-auto w-full h-[calc(100%_-_180px)] px-5 desktop:w-[640px]  gap-2.5 flex flex-col items-center justify-center',
      )}
    >
      <WarningIcon className="w-12 h-12 max-w-[3rem]" />

      <h2 className="text-h1 text-neutral-800 font-medium">Link Expired</h2>
      <p className="text-neutral-800 font-medium text-center">
        <p>The confirmation link has expired.</p>
        <p>
          Please connect with{' '}
          <a
            href={`mailto:${SUPPORT_EMAIL}`}
            className={twMerge('underline text-clc-blue')}
          >
            support team
          </a>{' '}
          to request new one
        </p>
      </p>
    </div>
  );
};

export default ExpiredToken;
